// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalReschedule_wrapper__KyUQH","label":"ModalReschedule_label__7niNT","value":"ModalReschedule_value__1ZFoG"};